import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import {
    SettingType, Setting, BlockType, ValidationMessage, ValidationMessageType,
    CodeBlock,
    SettingOption,
    TibboDataType,
    SettingState,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import * as micropython from './micropython';
import * as zephyr from './zephyr';
import * as tios from './tios';
import * as simulator from './simulator';
import { getFiles } from '../../Features/HTTPServer/micropython';


export default class ADC extends BasePeripheral {
    constructor() {
        super();
        this.id = 'adc';
        this.name = 'ADC Peripheral';
        this.fileLinks = [
        ];
        this.requirements = [['tios', 'zephyr']];

        for (let i = 0; i < this.settings.length; i++) {
            if (this.settings[i].id === 'NAME') {
                this.settings[i].dataType = TibboDataType.INTEGER;
            }
        }

        const settings: Array<Setting> = [
            {
                id: 'ENABLED',
                name: 'Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '1',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'PORT',
                name: 'Port',
                settingType: SettingType.OPTION,
                required: true,
                default: '',
            },
            {
                id: 'ADC',
                name: 'Analog Pin',
                settingType: SettingType.PIN,
                required: true,
                meta: 'adc',
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingOptions(settingId: string): SettingOption[] | undefined {
        if (settingId === 'PORT') {
            const options = [];
            const device = PlatformUtils.getDeviceDefinition(this.project.device.id);
            for (let i = 0; i < device.peripherals.length; i++) {
                if (device.peripherals[i].type === 'adc') {
                    options.push({
                        name: device.peripherals[i].id,
                        value: device.peripherals[i].settings.PORT.value,
                    });
                }
            }
            return options;
        }
        return super.getSettingOptions(settingId);
    }

    getFiles(): string[] {
        const files: string[] = super.getFiles();
        if (this.project.runtime === 'zephyr') {
            files.push('dts/bindings/adc,adc-devices.yml');
        }
        return files;
    }

    getState(settingId: string): SettingState {
        if (settingId === 'PORT') {
            const PIN = this.getSettingValue('ADC');
            if (PIN) {
                return SettingState.DISABLED;
            }
        }
        return super.getState(settingId);
    }

    // getSetting(settingId: string): Setting | undefined {
    //     const setting = super.getSetting(settingId);
    //     if (!setting) {
    //         return undefined;
    //     }
    //     if (settingId === 'NAME') {
    //         setting.dataType = TibboDataType.INTEGER;
    //         setting.default = '0';
    //     }
    //     return setting;
    // }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        if (this.getSettingValue('NAME').indexOf(' ') >= 0) {
            errors.push({ message: 'Name cannot contain spaces', messageType: ValidationMessageType.ERROR });
        }
        if (this.getSettingValue('ADC') === undefined) {
            errors.push({ message: `Analog pin not set for ${this.getSettingValue('NAME')}`, messageType: ValidationMessageType.ERROR });
        }
        return errors;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'simulator':
                return simulator.getCodeBlocks(this);
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/object_adc';
    }
}
